// import React, { useState } from 'react';
// import { Button, Modal, ModalBody, ModalHeader, Label} from 'reactstrap';
// import Sql_Preview_modal from './Sql_Preview_modal';
// import { format } from 'sql-formatter';


// const Chat_Sql_Modal = ({ show_sql_popup_query , database_id , sql_query } ) => {
//     const [modal_center, setmodal_center] = useState(false);

//     function tog_center() {
//         setmodal_center(!modal_center);
//     }
//   return (
//     <>
//      <Button className="btn rounded-pill" color="primary" onClick={() => tog_center()}><span style={{ color: '#ffff' }}><i class="mdi mdi-database-eye-outline"></i></span></Button>
    
//       {/* Vertically Centered */}
//       <Modal
//       size='xl'
//                 isOpen={modal_center}
//                 toggle={() => {
//                     tog_center();
//                 }}
//             >
//                 <ModalHeader className="modal-title" id="myModalLabel" toggle={() => { tog_center(); }}>
//                     SQL
//                 </ModalHeader>
//                 <ModalBody className="">
//                         <div className='sql-inner-wrap mb-3'>
//                             {/* <Label htmlFor="VertimeassageInput" className="form-label">Message</Label> */}
//                             <textarea disabled={true}  value={format(show_sql_popup_query)} className="form-control" id="VertimeassageInput" rows="20" placeholder="Enter your message"></textarea>                            
//                         </div>
//                         <div className="hstack gap-2 justify-content-end">
//                             <Button color="light" onClick={() => setmodal_center(false)}>Cancel</Button>
//                             {/* <Link to="#" className="btn btn-danger">Try Again</Link> */}
//                             <Sql_Preview_modal database_id={database_id} sql_query={sql_query} />
//                         </div>
                        
//                 </ModalBody>
//             </Modal>
//     </>
//   )
// }

// export default Chat_Sql_Modal

import React, { useState , useEffect } from 'react';
import { Button, Modal, ModalBody, ModalHeader,  UncontrolledTooltip, } from 'reactstrap';
import Sql_Preview_modal from './Sql_Preview_modal';
import { format } from 'sql-formatter';
import Highlight from 'react-highlight';
import Editor from 'react-simple-code-editor';
import 'highlight.js/styles/github.css'; // Theme
import hljs from "highlight.js/lib/core";
import { useSelector } from 'react-redux';

const Chat_Sql_Modal = ({ show_sql_popup_query, database_id, sql_query }) => {
  const [modal_center, setmodal_center] = useState(false);
  const [formatted_sql, setformatted_sql] = useState(show_sql_popup_query)
  const { loading , Database_Details_For_Bot } = useSelector((state) => state.BotDetails);
  useEffect(() => {
      try {
        let dialect = Database_Details_For_Bot?.connection.Type
        dialect = dialect.toLowerCase()
        if(dialect == 'mssql'){
          dialect = 'tsql'
        }

        setformatted_sql(format(show_sql_popup_query , { language: dialect }))
        console.log("Error formating SQL ")

        
      } catch (error) {
        console.log(error , "Error formating SQL ")
        setformatted_sql(show_sql_popup_query)
      }
  }, [show_sql_popup_query , modal_center , Database_Details_For_Bot])
  

  function tog_center() {
    setmodal_center(!modal_center);
  }

  return (
    <>
      <Button id="sql_pop" className="btn rounded-pill" color="primary" onClick={tog_center}>
        <span style={{ color: '#fff' }}>
          <i className="mdi mdi-database-eye-outline"></i>
        </span>
      </Button>
      <UncontrolledTooltip
        placement="left"
        target="sql_pop"
        className="leftmore"
        id="sql_pop"
      >
        SQL
      </UncontrolledTooltip>

      <Modal  modalClassName="custom-modal-outer" size="xl" isOpen={modal_center} toggle={tog_center}>
        <ModalHeader toggle={tog_center}>SQL</ModalHeader>
        <ModalBody>
            <Editor
                value={formatted_sql}
                onValueChange={(input)=>{
                  setformatted_sql(input)
                }}
                highlight={(code) => hljs.highlight(code, { language: "sql" }).value}
                padding={10}
                style={{
                fontFamily: '"Fira Code", monospace',
                fontSize: 14,
                border: "1px solid #ccc",
                borderRadius: "6px",
                minHeight: "150px",
                background: "transparent",
                whiteSpace: "pre-wrap",
                }}
            />
          <div className="hstack gap-2 justify-content-end mt-3">
            <Button color="light" onClick={() => setmodal_center(false)}>Cancel</Button>
            <Sql_Preview_modal database_id={database_id} sql_query={formatted_sql} />
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default Chat_Sql_Modal;
